module.exports = __webpack_public_path__ + "img/03-3-5数据治理.2c76d8c9.svg";